module.exports = __webpack_public_path__ + "static/01-2-cd5b51a726d5f01485c3c7831b91c90b.jpg";